export default {
    'export': 'Exportar',
    'export-as-excel': 'Exportar a excel',
    'print-warehouse-inventory': 'Imprimir inventario de almacén',
    'search-by-material-name-or-num': 'Buscar número o nombre de material',
    warehouse: 'Almacén',
    'show-main-materials': 'Mostrar materiales principales',
    'only-materials-which-have-balances': 'Solo materiales con saldo',
    refresh: 'Actulaizar',
    cancel: 'Cancelar',
    'total-count': 'Número total',
    'total-quantity': 'Cantidad total',
    'warehouse-inventory': 'Inventario de almacén',
    'inventory-price': 'Precio de inventario',
    save: 'Guardar',

    warning: 'Alerta',
    'it-is-not-possible-to-set-main-material-inventory-price': '¡No se puede establecer un precio de inventario para un material principal!',

    headers: {
        'material-no': 'Número de artículo',
        'material-name': 'Nombre de artículo',
        count: '‎Conteo',
        'unit-size': 'Unidad',
        quantity: 'Cantidad',
        price: 'Precio',
        'total-amount': 'Valor',
    },

    'context-menu': {
        'edit-inventory-price': 'Editar precio de inventario',
        'material-statement': 'Estado de artículo',
    },
    
    'edit-inventory-price': 'Editar precio de inventario',
    'material-delivery-status': 'Estado de entrega de material'
}